import { getApi, patchApi } from 'apis';
import { ColumnPreference } from 'constants/payrollOverviewColumns';

/** Scoped to current user + company (UserCompanyRole.uiPreferences from JWT). */
export interface UiPreferencesPayload {
	payrollOverview: {
		columns: ColumnPreference[];
	};
}

export interface UiPreferencesResponse {
	uiPreferences: {
		payrollOverview: {
			columns: ColumnPreference[];
		};
	};
}

const getUiPreferences = async () => {
	return await getApi('/company/ui-preferences');
};

/** PATCH must include all 11 customizable columns; replaces stored uiPreferences. */
const updateUiPreferences = async (data: UiPreferencesPayload) => {
	return await patchApi('/company/ui-preferences', data);
};

export const uiPreferencesApi = {
	getUiPreferences,
	updateUiPreferences,
};
